module.exports = __webpack_public_path__ + "img/FR16989.253a8e08.png";